import { useState } from 'react'
import formatGBP from '../../utils/formatGBP'
// import { FaPlus as PlusIcon, FaMinus as MinusIcon } from "react-icons/fa6"
import { BsBoxArrowUpRight as ExternalLinkIcon } from 'react-icons/bs'
// import { CgUnavailable as Unavailable } from "react-icons/cg"
import DOMPurify from 'dompurify'

// NOTE: components
import Modal from '../ui/Modal'

interface ProductModalProps {
	show: boolean
	handleClose: () => void
	images: any
	vendor: string
	title: string
	handle: string
	description: string
	variants: any
}

const ProductModal = ({
	show,
	handleClose,
	images,
	vendor,
	handle,
	title,
	variants,
	description
}: ProductModalProps) => {
	const [selectedImage, setSelectedImage] = useState(images?.edges?.[0]?.node?.src)
	const sanitisedDescription = DOMPurify.sanitize(description)
	const [loading, setLoading] = useState(true)

	return (
		<Modal size="lg" show={show} onHide={handleClose} className="!overflow-visible">
			<Modal.Header onHide={handleClose} />
			<Modal.Body className="px-4 pt-0 sm:px-8">
				<div className="block pb-2 lg:hidden">
					<p className="font-medium">{vendor}</p>
					<p className="text-dark text-4xl font-bold">{title}</p>
					<div className="flex items-center gap-2">
						<p className="my-1 text-3xl">{formatGBP(variants?.edges?.[0]?.node?.price?.amount)}</p>
					</div>
					<a
						href={`https://www.behelfy.com/products/${handle}`}
						target="_blank"
						rel="noreferrer"
						className="mb-6 mt-4 flex w-full items-center justify-center whitespace-nowrap rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-10 py-2 font-semibold text-white shadow hover:text-white"
					>
						<span>Buy now</span>
						<ExternalLinkIcon className="my-auto ml-2" />
					</a>
				</div>
				<div className="pb-5 sm:pb-10 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8">
					<div>
						<div role="button" tabIndex={0}>
							<div className="relative">
								{loading && <div className="skeleton rounded-lg h-[398px] absolute inset-0" />}

								<img
									src={selectedImage}
									alt={title}
									className="w-full rounded-lg object-cover"
									loading="eager"
									onLoad={() => setLoading(false)}
								/>
							</div>
						</div>
						<div className="mx-auto mt-6 w-full max-w-2xl sm:block lg:max-w-none">
							<div className="grid grid-cols-4 gap-6">
								{images?.edges.map((img: any, index: any) => (
									<button
										key={index}
										className={`relative h-24 cursor-pointer rounded-md ${selectedImage === img.node?.src ? 'ring-2 ring-gray-300' : ''}`}
										onClick={() => setSelectedImage(img.node?.src)}
									>
										<span className="absolute inset-0 overflow-hidden rounded-md">
											<ImgLoad
												imageSrc={img.node?.src}
												alt={`${title} thumbnail ${index}`}
											/>
										</span>
									</button>
								))}
							</div>
						</div>
					</div>

					<div className="mt-10 h-screen overflow-y-auto px-4 scrollbar-none sm:mt-16 sm:px-4 lg:mt-0">
						<div className="hidden lg:block">
							<p className="font-medium">{vendor}</p>
							<p className="text-dark text-4xl font-bold">{title}</p>
							<div className="flex items-center gap-2">
								<p className="my-1 text-3xl">
									{formatGBP(variants?.edges?.[0]?.node?.price?.amount)}
								</p>
							</div>

							<a
								href={`https://www.behelfy.com/products/${handle}`}
								target="_blank"
								rel="noreferrer"
								className="mb-6 mt-4 flex w-full items-center justify-center whitespace-nowrap rounded-full bg-gradient-to-r from-orange-600 to-orange-500 px-10 py-2 font-semibold text-white shadow hover:text-white"
							>
								<span>Buy now</span>
								<ExternalLinkIcon className="my-auto ml-2" />
							</a>
						</div>
						<div className="mt-6" dangerouslySetInnerHTML={{ __html: sanitisedDescription }} />
					</div>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default ProductModal

interface ImgLoadProps {
    imageSrc: string
    alt: string
}

// NOTE: used to render product modal gallery images
const ImgLoad = ({ imageSrc, alt }: ImgLoadProps) => {
    const [loading, setLoading] = useState(true)
    
    return (
        <>
            {loading && <div className="skeleton h-24 rounded-md" />}

            <img
                src={imageSrc}
                alt={alt}
                className="size-full object-cover"
                onLoad={() => setLoading(false)}
            />
        </>
    )
}



{/* // TODO: Create an option component to solve selected option */ }
// const [selectedOption, setSelectedOption] = useState(options?.[0]?.node?.title)
// const [quantity, setQuantity] = useState(1)
{/* <div className="mt-6">
              {options.map((option: any) => (
                <div key={option.id} className="mt-6">
                  <p className="text-sm font-medium">{option.name}</p>

                  <div className="flex flex-wrap sm:flex-nowrap items-center gap-3 mt-2">
                    {option?.values?.map((vals: any, index: any) => (
                      <button
                        key={index}
                        onClick={() => setSelectedOption(vals)}
                        className={`text-black bg-[#F5F0EB] font-medium rounded-lg text-sm px-5 py-2.5 w-full text-center ${selectedOption === vals ? "bg-black text-white" : ""}`}
                      >
                        {vals}
                      </button>
                    ))}
                  </div>
                </div>
              ))} 
            </div>*/}

{/* // TODO: Implement when we send then strait to checkout */ }
{/* <div className="mt-6">
              <p className="text-sm font-medium">Quantity</p>

              <div className="flex items-center mt-2 max-w-[10rem]">
                <button
                  className="bg-[#F5F0EB] rounded-s-lg p-3 h-12 disabled:opacity-50"
                  disabled={quantity <= 0}
                  onClick={() => setQuantity((previousQuantity) => previousQuantity - 1)}
                >
                  <MinusIcon className="size-4 text-gray-700" />
                </button>

                <input
                  type="number"
                  min={1}
                  max={stock}
                  value={quantity}
                  required
                  onChange={(e) => setQuantity(+e.target.value)}
                  className="bg-[#F5F0EB] border-x-0 h-12 text-center text-dark text-lg block w-full py-2.5"
                />

                <button
                  className="bg-[#F5F0EB] rounded-e-lg p-3 h-12 disabled:opacity-50"
                  disabled={quantity === stock}
                  onClick={() => setQuantity((previousQuantity) => previousQuantity + 1)}
                >
                  <PlusIcon className="size-4 text-gray-700" />
                </button>
              </div>
            </div> */}

{/* // TODO: Implement sold out pill when integrating checkout - problem on products that have stock showing up as sold out */ }
{/* {stock > 0 ? ( */ }

{/* ) : (
              <span className="flex items-center justify-center gap-2 w-full rounded-full cursor-not-allowed mt-10  px-10 py-1.5 shadow bg-[#F5F0EB]">
                <Unavailable className="text-2xl" />
                <span className="text-xl">Sold out</span> 
              </span>
            )} */}
